import styled from "@emotion/styled";
import * as React from "react";
import { Link } from "react-router-dom";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const StyledContainer = styled.div`
  width: calc(100% - 20px);
  max-width: 1200px;
  min-height: 455px;
  border-radius: 8px;
  border: solid 1px
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.borderColor
    };
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  box-sizing: border-box;

  &:last-child {
    margin-right: 0;
  }
`;

export const Divider = styled.div`
  border-bottom: solid 1px
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.borderColor
    };
  margin: 20px 0;
`;

export const StyledAnchorContainer = styled(Link)`
  display: block;
  text-decoration: none !important;
  cursor: pointer;
`;

export const StyledLink = styled.div`
  text-decoration: none !important;
`;

interface ILinkWrapperProps {
  href?: string;
  onClick?(): void;
  children: React.ReactNode;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const AnchorWrapper: React.FC<ILinkWrapperProps> = ({ href, onClick = () => {}, children }) =>
  href ? (
    <StyledAnchorContainer to={href} onClick={onClick}>
      {children}
    </StyledAnchorContainer>
  ) : (
    <div>{children}</div>
  );
